module.exports = __webpack_public_path__ + "static/assets/9196b28a5b92e4cea4e8fd3cd867a000.png";